<template>
<div id="vip-page">
    <template v-if="!noData">
        <div class="vip-header">
            欢迎加入苏宁红孩子VIP Club <br/>
            开启专属会员特权
        </div>
        <div class="vip-icon">
            <div class="base-benefits" v-if="baseBenefits.length > 0">
                <h2>基本权益</h2>
                <div class="icon-list" v-for="item in baseBenefits">
                    <div class="icon-header" @click="goUrl(item.redirectUrl)">
                        <img :src="item.iconUrl | urlProtocol" alt="">
                        <h3>{{item.showName}}</h3>
                    </div>
                    <div class="icon-tips">
                        {{item.describer}}
                    </div>
                </div>
            </div>
            <div class="base-benefits" v-if="storeBenefits.length > 0">
                <h2>本店专属权益</h2>
                <div class="icon-list" v-for="item in storeBenefits">
                    <div class="icon-header" @click="goUrl(item.redirectUrl)">
                        <img :src="item.iconUrl | urlProtocol" alt="">
                        <h3>{{item.showName}}</h3>
                    </div>
                    <div class="icon-tips">
                        {{item.describer}}
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="no-vip">
            <h2>暂无会员权益数据，敬请期待~</h2>
            <p>“咦，这里空空的，还是去别处看看吧～”</p>
        </div>
    </template>
</div>
</template>
<script>

    import {Util} from '../commons/util'
    import Server from '../services/Entrance'

    export default {
        name: 'Vip',
        data () {
            return {
                baseBenefits: [],
                storeBenefits: [],
                noData: false
            }
        },
        // 生命周期钩子
        mounted () {
            this.bodyHeight = window.screen.height + 'px';

            document.title = '会员权益';
            if ($.isApp) {
                $.AppReady().done(function (Bridge) {
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.documentNavStyle();
                        Bridge.setNewPageTitle("", "10009-null-100043/null-身边苏宁/会员权益-null-null-null");
                    } else if ($.os.android) {
                        Bridge.setText({
                            titleText: '会员权益'
                        });
                        Bridge.setNewPageTitle("10009-null-100043/null-身边苏宁/会员权益-null-null-null");
                    }
                })
            }
        },
        beforeRouteEnter(to, from, next) {

            let urlParams = to.params;

            Server.mycenter.vipBenefits(urlParams.storeCode).then(data => {
                next(vm => {

                    let baseBenefits = [],
                        storeBenefits = [];
                    if (data) {
                        for (let i = 0, len = data.length; i < len; i++) {
                            if (data[i].benefitsType == 1) {
                                baseBenefits.push(data[i]);
                            } else {
                                storeBenefits.push(data[i]);
                            }
                        }

                        vm.baseBenefits = baseBenefits;
                        vm.storeBenefits = storeBenefits;
                    }

                    if (baseBenefits.length === 0 && storeBenefits.length === 0) {
                        vm.noData = true;
                    }
                });
            });
        },
        components: {
        },
        methods: {
            goUrl(url) {

                if (!url) {
                    return;
                }
                window.location.href = url;
            }
        }
    }
</script>
<style scoped>
.vip-header {
    box-sizing: border-box;
    padding: 30px 60px;
    background:#fff2de;
    width:750px;
    height:150px;
    font-size:30px;
    color:#333333;
    letter-spacing:0;
    line-height:45px;
    text-align:left;
    position: relative;

    &:after {
         position: absolute;
         top: 50%;
         margin-top: -64px;
         right: 60px;
         content: '';
         display: block;
         background: url("../assets/vip-icon.png") center center no-repeat;
         background-size: 128px 128px;
         width: 128px;
         height: 128px;
     }
}
.vip-icon {
    border-top: 10px solid #f2f2f2;

    .base-benefits {
        border-bottom: 10px solid #f2f2f2;
        overflow: hidden;
        height: auto;

        h2 {
            padding: 20px 20px 0 20px;
            margin-bottom: 30px;
            font-size:28px;
            color:#222222;
        }
    }

    .icon-list {
        margin: 0 20px 30px 20px;
        width: 335px;
        height: 216px;
        float: left;
        overflow: hidden;
    }
    .icon-header {
        width: 100%;
        height: 88px;
        img {
            border-radius: 50%;
            float: left;
            display: block;
            width: 88px;
            height: 88px;
        }
        h3 {
            margin-left: 20px;
            float: left;
            height: 88px;
            line-height: 88px;
            font-size:30px;
            color:#222222;
        }
    }
    .icon-tips {
        margin-top: 10px;
        font-size:26px;
        color:#444444;
        letter-spacing:0.74px;
    }
}

.no-vip {
    &:before {
         margin: 320px auto 41px auto;
         display: block;
         content: '';
         width: 256px;
         height: 298px;
         background: url("../assets/no-vip.png") 50% 50% no-repeat;
         background-size: 256px 298px;
     }

    h2 {
        font-family:"PingFangSC-Medium";
        font-size:34px;
        font-weight: 800;
        text-align: center;
        color:#323232;
        width: 100%;
    }

    p {
        font-family:"PingFangSC-Regular";
        font-size:28px;
        color:#666666;
        text-align:center;
        display: block;
        width: 100%;
        margin-top: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/Vip.vue